export const reviewsSelector = (state) => state.reviews;